RivalIQ.apps.Shell.module('enums', function (enums, App, Backbone, Marionette, $, _) {

    'use strict';

    enums.notifications = {
        TRIAL_EXPIRES_SOON: 'trial_expires_soon',
        TRIAL_EXPIRES_SOON_NON_TRIAL_PLAN: 'trial_expires_soon_non_trial_plan',
        TRIAL_EXPIRED: 'trial_expired',
        TRIAL: 'trial',
        TRIAL_KEY_GEO: 'trial_key_geo',
        CANCELED: 'account_canceled',
        RENEWAL_CENTER: 'renewal_center',
        PAYMENT_OVERDUE: 'contract_payment_overdue',
        EXPIRED_TOKENS: 'expired_tokens'
    };

    enums.navigation_size = {
        DEFAULT: 'default',
        TALL: 'tall',
        SHORT: 'short'
    };

});
